module.exports = __webpack_public_path__ + "static/media/calendar-thumbnail.80fdf29d.PNG";